import TxRenderedPdfs from "./components/TxRenderedPdfs";
import TxRendererQuery from "./components/TxRendererQuery";
import TxRendererStatus from "./components/TxRendererStatus";


export default {
    install(Vue, option) {
        Vue.component('TxRenderedPdfs',TxRenderedPdfs);
        Vue.component('TxRendererQuery',TxRendererQuery);
        Vue.component('TxRendererStatus',TxRendererStatus);
    }
};